import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamCustomerLogsRoute } from '@jira/router-routes__eoc-team-customer-logs-routes/src/eocTeamCustomerLogsRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as customerLogResources } from '@atlassian/eoc-customer-logs/resources';
import type { Route } from '@atlassian/react-resource-router';
import CustomerLogs, { LazyCustomerLogs } from './ui/spa/eoc/customer-logs/index.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocTeamCustomerLogsRouteEntry: Route = createEntry(eocTeamCustomerLogsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: CustomerLogs,
	layout: opsSettingsLayout,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...customerLogResources(),
	],

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyCustomerLogs],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
